import cn from 'classnames'
import React, { useMemo } from 'react'
import { toggleFavourite } from '../../favourites'
import { checkSessionIsFavourited, useFavourites } from '../hooks/useFavourites'
import { EventType, SessionType } from '../types'

export const Session = ({ session, event, style, className }) => {
  const favourites = useFavourites()
  const isFavourited = useMemo(() => checkSessionIsFavourited(favourites, event.id, session.id), [
    favourites,
    event.id,
    session.id,
  ])

  return (
    <div className={cn('schedule-event', className, isFavourited && 'schedule-event-favourited')} style={style}>
      <div
        className="schedule-event-inner"
        onMouseDown={e => e.preventDefault()}
        onClick={() => toggleFavourite(event.id, event.title, session.id)}>
        <svg width="16" height="16">
          <use xlinkHref={`/assets/glyphs/glyphs.svg?cachebust=2024#${isFavourited ? 'heart2' : 'heart2-outline'}`} />
        </svg>
      </div>
    </div>
  )
}

Session.propTypes = {
  session: SessionType,
  event: EventType,
}
